import { render, staticRenderFns } from "./chat-group-mode-tabs.vue?vue&type=template&id=f6f89098&scoped=true&"
import script from "./chat-group-mode-tabs.vue?vue&type=script&lang=js&"
export * from "./chat-group-mode-tabs.vue?vue&type=script&lang=js&"
import style0 from "./chat-group-mode-tabs.vue?vue&type=style&index=0&id=f6f89098&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f89098",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6f89098')) {
      api.createRecord('f6f89098', component.options)
    } else {
      api.reload('f6f89098', component.options)
    }
    module.hot.accept("./chat-group-mode-tabs.vue?vue&type=template&id=f6f89098&scoped=true&", function () {
      api.rerender('f6f89098', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/chat-group-mode-tabs/chat-group-mode-tabs.vue"
export default component.exports